import React from 'react';
import i18n from '../../../../../config/i18n';
import './styles/LoadingMessageItem.css';

const LoadingMessageItem = ({ style }) => (
  <div
    className="loading-message-item"
    style={style}
  >
    <span>{i18n.t('loading')}</span>
  </div>
);

export default LoadingMessageItem;



// WEBPACK FOOTER //
// ./src/modules/messaging/components/ChannelDetail/Message/LoadingMessageItem.js